import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { KEXP_PROPOSAL_PDF } from '../links'

const RFCP = () => {
  useEffect(() => {
    document.title = "Concept - Haight & Ashbury"
  }, [])

  return (
    <div>
      <section className="page-hero">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="mb-0">A New Chapter for Haight and Ashbury</h1>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto space-y-10 text-lg text-gray-800 leading-relaxed">
            <p>
              Following a multi-year public process to explore the future of the Doolan-Larson House and
              Storefronts, San Francisco Heritage has selected the proposal led by{' '}
              <strong>KEXP, in partnership with Blue Bear School of Music, Gensler, and Page &amp; Turnbull</strong>,
              to move forward into the next phase of planning.{' '}
              <a
                href={KEXP_PROPOSAL_PDF}
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4 text-haight-navy hover:text-black"
              >
                See the proposal here.
              </a>
            </p>

            <p>
              The selected concept envisions the historic property as a vibrant music and cultural
              center—bringing together live performance, radio broadcasting, music education, community
              gathering, and public programming at one of San Francisco&apos;s most iconic intersections. At
              its heart is a shared ambition to preserve the architectural integrity of the Doolan-Larson
              buildings while carrying forward the creative, independent, and countercultural spirit of
              Haight-Ashbury.
            </p>

            <p>
              <Link
                to="/press-release"
                className="bg-haight-navy text-white hover:bg-black active:bg-black font-normal py-3 px-6 inline-flex items-center justify-center min-h-11 w-full sm:w-auto text-center transition-colors duration-200"
              >
                Read the Press Release
              </Link>
            </p>

            <p>
              The proposal remains a developing vision rather than a final plan. Over the coming months,{' '}
              <strong>
                SF Heritage, KEXP, and Blue Bear School of Music will work together to refine the adaptive
                reuse program, engage the community, assess construction and financial feasibility, and
                establish a path toward implementation and potential future fundraising.
              </strong>
            </p>

            <blockquote className="border-l-4 border-haight-navy pl-6 py-1 text-gray-700 italic">
              <p>
                &ldquo;With KEXP and Blue Bear School of Music, we see an exciting future of preserving the
                integrity of the Doolan-Larson building, honoring the spirit of the counterculture, and
                ensuring the Haight Ashbury community thrives both economically and culturally.&rdquo;
              </p>
              <footer className="mt-3 not-italic text-base text-haight-navy">
                — Woody LaBounty, President &amp; CEO, San Francisco Heritage
              </footer>
            </blockquote>

            <div className="space-y-6">
              <h3 className="text-haight-navy">The Selection Process</h3>
              <p>
                The KEXP-led proposal emerged from an extensive process that began with{' '}
                <strong>13 initial concept submissions</strong> from organizations and creative teams imagining
                new uses for this nationally significant site.
              </p>

              <p>
                Historic preservation expert Brent Glass, former Director of the Smithsonian National Museum of
                American History, described the opportunity as one with significance far beyond the site
                itself:
              </p>

              <blockquote className="border-l-4 border-haight-navy pl-6 py-1 text-gray-700 italic">
                <p>
                  &ldquo;From the start, we envisioned this as a national model for adaptive reuse.&rdquo;
                </p>
              </blockquote>
            </div>

            <div className="space-y-6">
              <h2 className="text-haight-navy">Learn More</h2>
              <p>
                The ideas developed throughout this process remain an important part of the story of the
                Doolan-Larson project. You can read the press release and follow this website as
                the project evolves from concept toward implementation.
              </p>
              <p>
                Community participation will remain an important part of that process. We welcome ideas,
                feedback, and potential partnerships from neighbors, businesses, nonprofits, cultural
                organizations, and others who share an interest in the future of this landmark. Use the{' '}
                <strong>Comment</strong> link in the menu above to share your feedback.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default RFCP
